//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: ["dataConfig"],
  data() {
    return {
      QueryValue : null,
    };
  },
  methods: {
    $getSubmitData(){
      if(!this.QueryValue) return null;

      var formData = {};
      formData.QueryValue = this.QueryValue;
      return formData;

    },

    onSearch() {
      console.log("onSearch");
      this.$parent.$refreshForm();
    },

    onCancel() {
      console.log("onCancel");
    },

    onManySearch() {
      console.log("onManyQuery");
      this.$parent.onManySearchClick();
    }
  }
};
